// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"85ade6ab","114":"422c3685","371":"79dbb6ed","453":"ccb4c882"}[chunkId] + ".chunk.js";
};